function parseAttrs(s) {
  const out = {};
  const re = /([\w-]+)=(?:"([^"]*)"|'([^']*)'|([^\s\]]+))/g;
  let m;
  while (m = re.exec(s)) {
    var _ref, _ref2, _m$;
    out[m[1].toLowerCase()] = (_ref = (_ref2 = (_m$ = m[2]) != null ? _m$ : m[3]) != null ? _ref2 : m[4]) != null ? _ref : '';
  }
  return out;
}

/**
 * Parse the admin-authored index layout into a list of blocks. A line that is
 * exactly a shortcode (e.g. `[articles category="guides" limit="5"]`) becomes a
 * dynamic block; everything else is collected into `prose` blocks (rendered as
 * headings / paragraphs).
 *
 * Supported shortcodes:
 *   [articles]                              all articles
 *   [articles category="slug-or-id"]        articles in a category
 *   [articles limit="N"]                    most-recent N
 *   [articles ... title="Heading"]          optional heading above the list
 *   [article id="N"]                        link to one article
 *   [categories]                            the category list
 *   [html] ... [/html]                      raw HTML, verbatim
 *
 * The [html] block is the one place markup passes through untouched. Only
 * administrators can edit this setting, the same people who can already put
 * arbitrary markup in core's custom header and footer, so the trust level is
 * unchanged; everything else in the layout stays escaped.
 */
export function parseIndexLayout(text) {
  const blocks = [];
  let buf = [];
  const flush = () => {
    if (buf.some(l => l.trim() !== '')) {
      blocks.push({
        type: 'prose',
        attrs: {},
        lines: buf.slice()
      });
    }
    buf = [];
  };
  let html = null;
  (text || '').split('\n').forEach(line => {
    const trimmed = line.trim();

    // Inside an [html] block every line is content, including ones that look
    // like shortcodes, until the closing tag.
    if (html !== null) {
      if (trimmed.toLowerCase() === '[/html]') {
        blocks.push({
          type: 'html',
          attrs: {},
          lines: html
        });
        html = null;
      } else {
        html.push(line);
      }
      return;
    }
    if (trimmed.toLowerCase() === '[html]') {
      flush();
      html = [];
      return;
    }
    const m = trimmed.match(/^\[(\w[\w-]*)((?:\s+[\w-]+=(?:"[^"]*"|'[^']*'|[^\s\]]+))*)\s*\]$/);
    if (m) {
      flush();
      blocks.push({
        type: m[1].toLowerCase(),
        attrs: parseAttrs(m[2])
      });
    } else {
      buf.push(line);
    }
  });

  // An unclosed [html] still renders, rather than swallowing the rest of the
  // page into nothing.
  if (html !== null && html.length) {
    blocks.push({
      type: 'html',
      attrs: {},
      lines: html
    });
  }
  flush();
  return blocks;
}

/** True when at least one block needs article/category data fetched. */
export function layoutHasDynamicBlocks(blocks) {
  return blocks.some(b => b.type === 'articles' || b.type === 'article' || b.type === 'categories');
}
flarum.reg.add('linkrobins-wiki', 'forum/utils/indexLayout', { parseIndexLayout: parseIndexLayout,layoutHasDynamicBlocks: layoutHasDynamicBlocks, });